import React, {useEffect, useState} from "react";
import { Dialog, DialogContent } from "@mui/material";
import GenericDataGrid from "Admin/components/AdminComponents/GenericDataGrid";
import UpdateProfissionais from "./UpdateProfissionais";

function ListProfissionais() {
    const [pointer, setPointer] = useState(null)
    const [open, setOpen] = useState(false)

    const handleOpen = (id) =>{
      setPointer(id)
      setOpen(true);
    }

    const fields = [
      { name: 'nome', label: 'Nome' },
      { name: 'email', label: 'E-mail' },
      { 
        name: 'status', 
        label: 'Status',
        render: (item) => item.status ? 'Ativo' : 'Inativo'
      },
      { 
        name: 'receber_agendamento', 
        label: 'Recebe Agendamentos',
        render: (item) => item.receber_agendamento ? 'Sim' : 'Não'
      }
    ];

    const actions = [
      { label: 'Editar', handler: (item) => handleOpen(item.id) },
    ];

  return (
    <>
    <GenericDataGrid
      title="Listagem de Profissionais"
      endpoint="/profissionais"
      fields={fields}
      actions={actions}
    />
          <Dialog 
       open={open && pointer} 
       onClose={() => setOpen(false)} 
       PaperProps={{
        style: {
          width: '70vw',
          height: '80vh',
          maxWidth: 'none', 
          maxHeight: 'none',
          }
        }}
        >
        <DialogContent>
          <UpdateProfissionais id={pointer} />
        </DialogContent>
      </Dialog>
    </>

  );
}

export default ListProfissionais;